"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _useQueryParams = require("use-query-params");
var _parseToDateString = _interopRequireDefault(require("../constants/parseToDateString"));
var _DateParam = _interopRequireDefault(require("../utils/DateParam"));
const useDateParam = () => {
  const [startDate, setStartDate] = (0, _useQueryParams.useQueryParam)('startDate', _DateParam.default);
  const [selectedEndDate] = (0, _useQueryParams.useQueryParam)('endDate', _DateParam.default);
  if (selectedEndDate) {
    return [startDate && startDate === selectedEndDate ? new Date(startDate) : startDate ? new Date(startDate) : null, date => setStartDate(date ? (0, _parseToDateString.default)(date) : undefined, 'replaceIn')];
  }
  return [startDate ? new Date(startDate) : null, date => setStartDate(date ? (0, _parseToDateString.default)(date) : undefined, 'replaceIn')];
};
var _default = exports.default = useDateParam;